import { extractDate, extractTime } from '@/utils';

const renderDtStart = (value: string | undefined | null) => {
  if (!value) return 'No iniciado';

  return `${extractDate(value)} ${extractTime(value)}`;
};

export default renderDtStart;
